import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}
export function Input({
  label,
  error,
  id,
  className = '',
  ...props
}: InputProps) {
  const inputId = id || label.toLowerCase().replace(/\s+/g, '-');
  return <div className={`flex flex-col ${className}`} data-id="element-2">
      <label htmlFor={inputId} className="mb-2 text-xs font-medium tracking-widest text-gray-500 uppercase" data-id="element-3">
        {label}
      </label>
      <input id={inputId} className={`px-4 py-3 bg-transparent border ${error ? 'border-red-500' : 'border-gray-300'} focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors rounded-none placeholder:text-gray-400`} {...props} data-id="element-4" />
      {error && <span className="mt-1 text-xs text-red-500" data-id="element-5">{error}</span>}
    </div>;
}